import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CancelPendingPaymentsService } from '@payments/services/cancel-pending-payments/cancel-pending-payments.service';
import { RecentInvoicesCreditsComponent } from '../recent-invoices-credits.component';

@Component({
  selector: 'app-recent-invoices-credits-touch',
  templateUrl: './recent-invoices-credits-touch.component.html',
  styleUrls: ['./recent-invoices-credits-touch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecentInvoicesCreditsTouchComponent extends RecentInvoicesCreditsComponent {
  constructor(cancelPaymentsService: CancelPendingPaymentsService) {
    super(cancelPaymentsService);
  }
}
